import React, {useEffect, useRef, useState} from "react"
import api, {requestFailed} from "../Scripts/api"
import "../index.css"

function About() {

    const quoteRef = useRef(null)
    const divRef = useRef(null)
    const tagRef = useRef(null)
    const [quoteData, setQuoteData] = useState()

    const getQuote = () => {
        api.get(`/api/quotes`).then((response) => {
            setQuoteData(response.data[0])
        }).catch(requestFailed)
    }
    
    useEffect(() => {

        getQuote()

        const aboutDiv = divRef.current
        const quote = quoteRef.current
        const devTag = tagRef.current

        const expandMessage = setTimeout(() => {
            quote.style.marginBottom = '0'
            aboutDiv.style.height = '0'
            requestAnimationFrame(() => {
                quote.style.marginBottom = "2rem"
                aboutDiv.style.height = aboutDiv.scrollHeight + "px"
            })
        }, 2000)

        const showMessage = setTimeout(() => {
            aboutDiv.style.opacity = '0'
            requestAnimationFrame(() => {
                aboutDiv.style.opacity = "100"
            })
        }, 2300)

        const autoHeight = setTimeout(() => {
            aboutDiv.style.height = "auto"
        }, 3000)

        const showDevTag = setTimeout(() => {
            devTag.style.opacity = '0'
            requestAnimationFrame(() => {
                devTag.style.opacity = "100"
            })
        }, 4000)

        const fixDevTag = setTimeout(() => {
            devTag.style.transition = '0s'
        }, 4550)

        return () => {
            clearTimeout(expandMessage)
            clearTimeout(showMessage)
            clearTimeout(autoHeight)
            clearTimeout(showDevTag)
            clearTimeout(fixDevTag)
        }
    }, [])
    
    return (
        <div>
            <h3 id="quote">{quoteData ? quoteData.quote : ''}</h3>
            <h3 ref={quoteRef} id="quotee">— {quoteData ? quoteData.quotee : ''}</h3>
            <div ref={divRef} id="aboutdiv">
                <h3>
                    LVL UP (v0.5) is a project for those who seek to better themselves. If you are one of them, I hope
                    this empowers you to cultivate positive habits, embrace personal growth, and unlock your
                    full potential. I hope this challenges you to brave new horizons, persevere through failure,
                    and practice discipline. Regardless of who you are, where you are from, and what you are
                    dealing with, you being here proves that you share the human desire to improve and reach new
                    heights. If this project inspires you, even for just a moment, to become a better version of
                    yourself, then I have fulfilled my purpose. I am rooting for you.
                <br></br><br></br>
                x0x0, <a ref={tagRef} href="https://www.0xda.dev">0xDA</a></h3>
            </div>
        </div>
    )
}

export default About;
